export const WHEEL_PLANETS = [
  {
    name: 'Sun',
    circle: { cx: 0, cy: 0, r: 2.8 },
    lines: [
      [0, -4.2, 0, -6.2],
      [0, 4.2, 0, 6.2],
      [-4.2, 0, -6.2, 0],
      [4.2, 0, 6.2, 0],
      [-2.97, -2.97, -4.38, -4.38],
      [2.97, -2.97, 4.38, -4.38],
      [2.97, 2.97, 4.38, 4.38],
      [-2.97, 2.97, -4.38, 4.38],
    ],
  },
  { name: 'Moon', paths: ['M-1,-6 C-8,-6 -8,6 -1,6 C-5,6 -5,-6 -1,-6Z'] },
  {
    name: 'Mercury',
    circle: { cx: 0, cy: -0.5, r: 2.5 },
    paths: ['M-2.5,-3 A2.5,1.8 0 0,0 2.5,-3'],
    lines: [
      [0, 2, 0, 5.5],
      [-2, 4.2, 2, 4.2],
    ],
  },
  {
    name: 'Venus',
    circle: { cx: 0, cy: -1.5, r: 3 },
    lines: [
      [0, 1.5, 0, 5.5],
      [-2.5, 4, 2.5, 4],
    ],
  },
  {
    name: 'Mars',
    circle: { cx: -1.5, cy: 1.5, r: 3 },
    lines: [[1, -1, 5, -5]],
    polylines: [[2, -6.5, 5, -5, 6.5, -2]],
  },
  {
    name: 'Jupiter',
    paths: ['M-5,5 C-5,-2 -1,-6 3,-5.5'],
    lines: [
      [-5.5, 0, 5.5, 0],
      [3, -6.5, 3, 6.5],
    ],
  },
  {
    name: 'Saturn',
    lines: [
      [-1.5, -6, -1.5, 3],
      [-4, -3.5, 2, -3.5],
    ],
    paths: ['M-1.5,3 Q2,3 2,6'],
  },
  {
    name: 'Rahu',
    paths: ['M-5,-2 A5,5 0 0,0 5,-2'],
    lines: [
      [-5, -2, -5, 4.5],
      [5, -2, 5, 4.5],
    ],
  },
  {
    name: 'Ketu',
    paths: ['M-5,2 A5,5 0 0,1 5,2'],
    lines: [
      [-5, 2, -5, -4.5],
      [5, 2, 5, -4.5],
    ],
  },
]
